import { createSelector } from "reselect";
import { FormState } from "redux-form";

import { RootState } from "../../store/types";
import { Step4State } from "./reducer";
import * as constants from "./constants";
import { form } from "../../store/selectors";
import { ProjectInfoFormValues } from "./components/ProjectInfoForm";

export const step4 = (state: RootState): Step4State => state.step4;

// Current (rendered) and saved (post-submit) form values states
const currProjectForm = createSelector(
  form,
  state =>
    (state[constants.PROJECT_INFO_FORM] as FormState) ||
    ({ values: {} } as FormState),
);

export const currFormValues = createSelector(
  currProjectForm,
  state => state.values as ProjectInfoFormValues | undefined,
);

export const savedFormValues = createSelector(
  step4,
  state => state.projectFormValues,
);

// Switches between current (rendered) and saved (post-submit) form states (current preferred)
export const projFormValues = createSelector(
  currFormValues,
  savedFormValues,
  (current, saved) =>
    (Object.keys(current || {}).length
      ? current
      : saved) as ProjectInfoFormValues,
);

// Loading states
export const isDataLoading = createSelector(
  step4,
  state => state.isDataLoading,
);

// Data
export const industries = createSelector(step4, state =>
  state.industries.sort((a, b) => a.name.localeCompare(b.name)),
);

export const useDefaultDimensions = createSelector(
  step4,
  state => state.useDefaultDimensions,
);

// Force payment upfront if cost policy N/A or cost policy's min_payment_upfront specified
const summary = (state: RootState) => state.wizardSummary;
const costPolicy = createSelector(summary, state => state.costPolicy);

// Derived data/state
export const quantityUnit = createSelector(costPolicy, costPolicy => {
  if (!costPolicy) {
    return "";
  }
  // just show unit from DB, will do proper translation mapping later
  return costPolicy.unit;
});



// WEBPACK FOOTER //
// ./src/routes/Step4/selectors.ts